














import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { getGrayscale } from '../channel-service'
import { includes, filter, toArray, uniq, flatten, stubString } from 'lodash'

@Component({
  filters: {
    itemTypeFilter(val:string){
        if(val && val.length > 6){
          return val.substring(0 , 6)
        }
        return val
    }
  }
})
export default class RecoveryComponent extends Vue {
  @Prop({ default: () => [] }) readonly data!: any[]

  selected = 0
  showIndex = 8
  itemTypeList: any = [] //cms配的数据
  itemType1List: any = [] //项目类型1
  itemType2List: any = [] //项目类型2

  async created() {
    this.itemTypeList = await getGrayscale()
    this.itemType1List = uniq(
      flatten(
        this.data.map((item: any) => {
          return item.itemType1
        })
      )
    )
    this.itemType2List = uniq(
      flatten(
        this.data.map((item: any) => {
          return item.itemType2
        })
      )
    )
    this.$nextTick(() => {
      const el = this.$el
      if (el) {
        const rect = el.getBoundingClientRect()
        this.$emit('set-height', rect.height)
      }
    })
  }

  get tagList() {
    const itemTypeList = filter(this.itemTypeList, (item: any) => {
      return item.isType1 ? includes(this.itemType1List, item.itemType) : includes(this.itemType2List, item.itemType)
    })
    const list = itemTypeList && itemTypeList.length > 0 ? [{ itemType: '全部', isAll: true }, ...itemTypeList] : []
    
    return list
  }

  get showTagMore() {
    return this.tagList.length > 8 && this.showIndex < 9
  }

  get showMoreBtn() {
    return this.tagList.length > 8
  }

  clickItem(item: any) {
    location.href = item.link
  }
  showAllTag() {
    this.showIndex = this.showIndex === 8 ? Infinity : 8
    this.$nextTick(() => {
      const el = this.$el
      if (el) {
        const rect = el.getBoundingClientRect()
        this.$emit('set-height', rect.height)
      }
    })
  }

  @Emit()
  changeTag(item: any, index: number) {
    this.selected = index
    return item
  }
}
